import request from '@/util/http.js'
export const userList = (query) => {
  return request({
    url: '/user/userList',
    method: 'get',
    params: query
  })
}
// 删除员工
export const deleteUser = (data) => {
  return request({
    url: '/user/deleteUser',
    method: 'delete',
    data: data
  })
}
// 添加员工
export const addUser = (data) => {
  return request({
    url: '/user/userAdd',
    method: 'post',
    data: data
  })
}
// 编辑员工
export const editUser = (data) => {
  return request({
    url: '/user/userEdit',
    method: 'post',
    data: data
  })
}
// 获取菜单
export const getUserMenu = (query) => {
  return request({
    url: '/user/menu',
    method: 'get',
    params: query
  })
}
// 编辑权限
export const editUserPermission = (data) => {
  return request({
    url: '/user/editUserPermission',
    method: 'post',
    data: data
  })
}
//    获取用户权限
export const getUserPermission = (query) => {
  return request({
    url: '/user/getUserPermission',
    method: 'get',
    params: query
  })
}
// 操作日志
export const operationLogList = (query) => {
  return request({
    url: '/user/operationLogList',
    method: 'get',
    params: query
  })
}

// 项目列表
export const depList = (query) => {
  return request({
    url: '/user/depList',
    method: 'get',
    params: query
  })
}
// 添加项目
export const addDep = (data) => {
  return request({
    url: '/user/addDep',
    method: 'post',
    data: data
  })
}
// 修改项目
export const editDep = (data) => {
  return request({
    url: '/user/editDep',
    method: 'post',
    data: data
  })
}
// 删除项目
export const deleteDep = (data) => {
  return request({
    url: '/user/deleteDep',
    method: 'delete',
    data: data
  })
}